var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPensionPlanAdventurous = function SvgPensionPlanAdventurous(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 813,
    height: 152,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pension-plan-adventurous_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#320327",
    d: "M0 10C0 4.477 4.477 0 10 0h793c5.523 0 10 4.477 10 10v132c0 5.523-4.477 10-10 10H10c-5.523 0-10-4.477-10-10z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D93657",
    clipPath: "url(#pension-plan-adventurous_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407 35.56-41.44 484h69.771L407 105.331 785.669 484h69.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-157 461.292V484h47.062L407-32.938 923.938 484H971v-22.708l-564-564z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-157 323.023v69.771l564-564 564 564v-69.771L407-240.976z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-157 184.754v69.77l564-564 564 564v-69.77L407-379.209z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-157 46.485v69.771l564-563.963 564 563.963v-69.77L407-517.478z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pension-plan-adventurous_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 10C0 4.477 4.477 0 10 0h793c5.523 0 10 4.477 10 10v132c0 5.523-4.477 10-10 10H10c-5.523 0-10-4.477-10-10z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pension-plan-adventurous_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M971 484H-157V-644H971z"
  })))));
};
export { SvgPensionPlanAdventurous as ReactComponent };
export default __webpack_public_path__ + "images/pension-plan-adventurous.svg";